// 牛商云登陆
import userApi from '@/api/user.api'
import { getUser, setUser, removeUser } from '@/utils/auth'
import { Message } from 'element-ui'

const wxData = window.sessionStorage.getItem('wxData') ? JSON.parse(window.sessionStorage.getItem('wxData')) : null
const openid = window.sessionStorage.getItem('openid')

const state = {
	user: getUser(),
	wxData,
	openid,
	roles: []
}

const getters = {
	userInfo: state => {
		return state.user
	}
}

const mutations = {
	SET_USER: (state, user) => {
		state.user = user
		setUser(JSON.stringify(user))
	},
	SET_WX_DATA: (state, wxData) => {
		window.sessionStorage.setItem('wxData', JSON.stringify(wxData))
		state.wxData = wxData
	},
	SET_OPEN_ID: (state, openid) => {
		window.sessionStorage.setItem('openid', openid)
		state.openid = openid
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	}
}

const actions = {
	//  牛商云接口
	// 获取用户信息
	getFrontUserInfo({ commit }) {
		return new Promise((resolve, reject) => {
			try{
				userApi.frontUserInfo().then(res => {
					if (res.data.isSuccess) {
						const userInfo = getUser()
						if(userInfo && userInfo.token != '' ) {
							res.data.data.token = userInfo.token
						}
						resolve(res.data.data)
						commit('SET_USER', res.data.data)
					} else {
						resolve(false)
						console.log('未登录')
					}
				}, () => {
					resolve(false)
				} )
			} catch(err) {
				resolve(false)
			}
		})

	},
	// 登录
	async loginUser({ commit }, params) {
		const { data } = await userApi.login(params)
		if (data.isSuccess) {
			data.data.cookie = document && document.cookie ? document.cookie : 0
			commit('SET_USER', data.data)
			const enterpriseInfo = await userApi.enterpriseInfo()
			if (enterpriseInfo.data.isSuccess && enterpriseInfo.data.data && enterpriseInfo.data.data.param) {
				localStorage.setItem('AI_CONTENT', enterpriseInfo.data.data.param.includes('AI'))
			} else {
				localStorage.setItem('AI_CONTENT', false)
			}
		}
		return data
	},
	// 免密登录
	async authorizeLogin({ commit }, params) {
		const { data } = await userApi.authorizeLogin(params)
		if (data.isSuccess) {
			data.data.token = params.token
			data.data.cookie = document && document.cookie ? document.cookie : 0
			commit('SET_USER', data.data)
		}
		return data
	},
	// 登出
	logoutUser({ commit }) {
		userApi.logout().then(data => {
			if (data.data.isSuccess) {
				commit('SET_USER', null)
				removeUser()
				sessionStorage.clear()
				window.location.reload()
			}
		})
	},

	// 获取验证码
	getUserCode(context, params) {
		return userApi.getCode(params)
	},

	// 验证验证码是否正确
	getCheckCode(context, params) {
		return userApi.checkCode(params)
	},

	// 注册
	getRegister(context, params) {
		return userApi.register(params)
	},

	// 验证手机是否可用
	getCheckPhone(context, params) {
		return userApi.checkPhone(params)
	},

	// 用户旧密码校验
	postCheckPassword(context, params) {
		return userApi.checkPassword(params)
	},

	// 用户修改密码
	postUpdatePassword(context, params) {
		return userApi.updatePassword(params)
	},

	// 更换绑定手机
	getUpdateMobile(context, params) {
		return userApi.updateMobile(params)
	},

	// 获取二维码
	getQrAuthorize(context, params) {
		return userApi.qrAuthorize(params)
	},
	// 获取老板的二维码
	getUserInfo(context, params) {
		return userApi.getUserInfo(params)
	},
	// 判断是否搬到老板微信
	getIsBand(context, params) {
		return userApi.getIsBand(params)
	},

	// 二维码确定后获取用户信息
	async getUserLoginByCode({ commit, state }, params) {
		const { data } = await userApi.userLoginByCode(params)
		if (data.isSuccess) {
			data.data.cookie = document && document.cookie ? document.cookie : 0
			commit('SET_USER', data.data)
			commit('SET_OPEN_ID', params.openid)
		}
		return data
	},
	// 更新微信绑定
	getUpdateQrOpenid(context, params) {
		return userApi.updateQrOpenid(params)
	},

	// 解绑微信
	getUnbingQrOpenid(context, params) {
		return userApi.unbingQrOpenid(params)
	},

	// 获取企业信息
	getEnterpriseInfo(context) {
		return userApi.enterpriseInfo()
	},

	// 保存企业信息
	postSaveEnterpriseInfo(context, params) {
		return userApi.saveEnterpriseInfo(params)
	},

	// 七牛toKen
	getUptoken(context) {
		return userApi.upToken()
	},

	// 取消用户提示
	getUpdTipStatus(context, params) {
		return userApi.updTipStatus(params)
	},

	// 找回密码验，证码验证+修改密码
	postChangepwd(context, params) {
		return userApi.changepwd(params)
	},

	// 判断用户是否开通视频云
	getUserAuthorityFn(context, params) {
		return userApi.getUserBuyAuthority(params)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
